import React, { Component } from 'react'
import ReactTable from 'react-table'
import moment from 'moment'
import { Tooltip } from 'antd'
import { filterCaseInsensitive } from '../../../util'

class Leads extends Component {
  render() {
    const { contactLeads, handleRowLeadsClick } = this.props
    return (
      <div>
        <div className="row">
          <div className="col-md-6">
            <h4>Leads</h4>
          </div>
        </div>
        <ReactTable
          data={contactLeads}
          filterable
          defaultFilterMethod={filterCaseInsensitive}
          getTrProps={(state, rowInfo, column, instance) => ({
            onClick: e => handleRowLeadsClick(rowInfo.original)
          })}
          columns={[
            {
              columns: [
                {
                  Header: 'Name',
                  id: 'name',
                  accessor: 'name',
                  Cell: d => <Tooltip title={d.original.name}>{d.original.name}</Tooltip>
                },
                {
                  Header: 'Type',
                  id: 'type',
                  accessor: 'type',
                  Cell: d => <Tooltip title={d.original.type}>{d.original.type}</Tooltip>
                },
                {
                  Header: 'Created Date',
                  id: 'created_date',
                  accessor: d => moment.utc(d.created_date).format('M/D/YYYY'),
                  minWidth: 70
                }
              ]
            }
          ]}
          defaultPageSize={5}
          className="-striped -highlight"
        />
      </div>
    )
  }
}

export default Leads



// WEBPACK FOOTER //
// ./src/components/jobs/contacts/Leads.js